import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import './QRForm.css';

function GenericQR() {
  const [url, setUrl] = useState('');
  const [qrCode, setQrCode] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!url) {
      setError('Please enter a URL');
      return;
    }

    setQrCode(url);
  };

  const handleDownload = () => {
    const canvas = document.getElementById('generic-qr-canvas');
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'qr-code.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(url);
    alert('URL copied to clipboard!');
  };

  return (
    <div className="qr-form">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="url">Enter URL:</label>
          <input
            type="url"
            id="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://example.com"
            required
          />
        </div>

        <button type="submit" className="submit-button">
          Generate QR Code
        </button>
      </form>

      {error && <div className="error-message">{error}</div>}

      {qrCode && (
        <div className="qr-result">
          <h3>Your QR Code:</h3>
          <div style={{ display: 'none' }}>
            <QRCodeCanvas id="generic-qr-canvas" value={qrCode} size={300} level="L" />
          </div>
          <div className="qr-display">
            <QRCodeCanvas value={qrCode} size={300} level="L" />
          </div>
          
          <div className="url-display">
            <strong>URL:</strong>
            <div className="url-text">{qrCode}</div>
          </div>

          <div className="action-buttons">
            <button onClick={handleDownload} className="action-button download">
              Download QR Code
            </button>
            <button onClick={handleCopyUrl} className="action-button copy">
              Copy URL
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default GenericQR;